(function () {
  'use strict';

  angular.module('ringbaPortal').component('campaignOfferStatus', {
    controller: CampaignOfferStatusController,
    bindings: {
      offer: '<'
    },
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/campaign-offer-status/campaign-offer-status.view.html'
  });

  function CampaignOfferStatusController(
    $filter,
    dateTimeService,
    moment
  ) {
    'ngInject';

    const vm = this;

    const offerStatus = {
      'inactive': {
        text: 'OFFER_INACTIVE_STATUS',
        css: 'grey_status'
      },
      'enabled': {
        text: 'OFFER_ACTIVE_STATUS',
        css: 'green_status'
      },
      'paused': {
        text: 'OFFER_PAUSED_STATUS',
        css: 'yellow_status'
      },
      'expired': {
        text: 'OFFER_EXPIRED_STATUS',
        css: 'red_status'
      },
      'aboutToExpire': {
        text: 'OFFER_EXPIRING_STATUS'
      }
    };

    vm.$onChanges = onChanges;

    function onChanges() {
      _setOfferStatus(vm.offer);
    }

    function _setOfferStatus(publishedOffer) {
      vm.campaignOfferStatus = $filter('translate')(offerStatus['inactive'].text);
      vm.campaignOfferStatusClass = offerStatus['inactive'].css;

      if (publishedOffer) {
        vm.campaignOfferStatus = _getPublishedOfferStatus(publishedOffer).text;
        vm.campaignOfferStatusClass = _getPublishedOfferStatus(publishedOffer).css;
      }
    }

    function _getPublishedOfferStatus(publishedOffer) {
      vm.offerAboutToExpire = false;
      if (publishedOffer.offerState === 'paused') {
        return {
          text: $filter('translate')(offerStatus['paused'].text),
          css: offerStatus['paused'].css
        };
      } else if (publishedOffer.offerState === 'expired' || (publishedOffer.offerState === 'enabled' && _checkIfOfferExpired(publishedOffer))) {
        return {
          text: $filter('translate')(offerStatus['expired'].text),
          css: offerStatus['expired'].css
        };
      } else if (publishedOffer.offerState === 'enabled') {
        const durationText = _checkIfOfferAboutToExpire(publishedOffer);
        vm.offerAboutToExpire = !!durationText;
        const text = vm.offerAboutToExpire ? $filter('translate')(offerStatus['aboutToExpire'].text, { time: durationText }) : $filter('translate')(offerStatus['enabled'].text);
        return {
          text: text,
          css: offerStatus['enabled'].css
        };
      }
    }

    function _checkIfOfferExpired(publishedOffer) {
      if (publishedOffer && publishedOffer.expiration) {
        const currentMoment = dateTimeService.getCurrentMomentInTimeZone(vm.offer.timeZoneId);
        const endMoment = moment(publishedOffer.expiration);
        return endMoment.isBefore(currentMoment);
      }
    }

    function _checkIfOfferAboutToExpire(publishedOffer) {
      if (publishedOffer && publishedOffer.expiration) {
        const endMoment = moment(publishedOffer.expiration);
        const currentMoment = dateTimeService.getCurrentMomentInTimeZone(vm.offer.timeZoneId);
        if (endMoment.diff(currentMoment, 'days') <= 2) {
          return _getExpireText(endMoment);
        }
        return '';
      }
      return '';
    }

    function _getExpireText(endMoment) {
      const currentMoment = dateTimeService.getCurrentMomentInTimeZone(vm.offer.timeZoneId);
      const duration = moment.duration(endMoment.diff(currentMoment));
      return _.capitalize(duration.humanize());
    }


  }
})();
